import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  path?: string;
}

interface Props {
  eyebrow: string;
  title: string;
  subtitle: string;
  crumbs: Crumb[];
  image: string;
}

export default function PageHeader({ eyebrow, title, subtitle, crumbs, image }: Props) {
  return (
    <header className="relative flex min-h-[300px] w-full items-end md:min-h-[360px]">
      <div className="absolute inset-0">
        <img src={image} alt={title} className="h-full w-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-background-950/60 to-background-950/40"></div>

      <nav aria-label="面包屑" className="relative w-full">
        <div className="mx-auto max-w-7xl px-4 pb-8 pt-24 md:px-6 md:pt-28">
          <ol className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-100/70">
            {crumbs.map((c, i) => (
              <li key={c.label} className="flex items-center gap-1.5">
                {i > 0 && <i className="ri-arrow-right-s-line" />}
                {c.path ? (
                  <Link to={c.path} className="transition-colors hover:text-accent-300">
                    {c.label}
                  </Link>
                ) : (
                  <span className="text-accent-300">{c.label}</span>
                )}
              </li>
            ))}
          </ol>
          <p className="mt-4 text-xs font-medium tracking-[0.3em] text-accent-300">{eyebrow}</p>
          <h1 className="mt-2 font-heading text-3xl font-bold text-background-50 md:text-5xl">{title}</h1>
          <p className="mt-3 max-w-2xl text-sm leading-7 text-foreground-100/85">{subtitle}</p>
        </div>
      </nav>
    </header>
  );
}